import React from "react";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";
import medal from "../../assests/medal.png";
import nodatafound from "../../assests/nodatafound.png";
import { setDataToLocalStorage } from "../../services/localStorage";
export function CompletedCourses({ onCLickEmptyEnroll }) {
  const { LearningStore } = useStores();
  return (
    <div>
      <p className="text-[20px] md:px-8 lg:px-8 text-black lg:text-xl lg:py-3 lg:font-semibold ">
        Completed Courses
      </p>
      <div className=" mt-1 my-3 md:mx-8 lg:mx-8 w-[100%] ">
        <div className="flex py-3 overflow-scroll no-scrollbar w-[95%]">
          {LearningStore.enrolledCourses.length === 0 ? (
            <div className="flex ml-10 w-full">
              <img src={nodatafound} alt="No data found" />
            </div>
          ) : (
            // {
            LearningStore.enrolledCourses
              .slice()
              .sort((a, b) => b.createdAt - a.createdAt)
              .map((enroll, index) => {
                return Progress_bar2({
                  label: enroll?.course?.title,
                  score: LearningStore.getTheCourseCompletionPercentage(
                    enroll?.course?._id
                  ),
                  image: enroll?.course?.image,
                  key: index,
                  id: enroll?.course?._id,
                });
                // <div className="flex flex-row justify-center items-center w-[50%] overflow-x-scroll no-scrollbar ">
                //   <img className="w-[90px] h-[90px] rounded-full p-2 border-2 border-primary" src={course?.image} alt="" />
                // </div>
              })
            // }
          )}
        </div>
      </div>
    </div>
  );
}
export function Progress_bar2({ label, image, score, key, id }) {
  const navigate = useNavigate();

  const { LearningStore, UserStore, CommonStore } = useStores();

  const goToCourseById = (id) => {
    if (window.innerWidth > 768) {
      navigate(`/dashboard/course/${id}`);
    } else {
      navigate(`/course/${id}`);
    }
  };
  const navigateToCertificate = (currentCourseId) => {
    // if(window.innerWidth < 768){
    navigateToCourseCertificate(currentCourseId);
    // }
    // else{
    // // navigate.push
    // navigate(`/dashboard/course/${LearningStore.currentCourse?._id}/certificate`);
    // setCollapse(true)
    // }
  };
  const navigateToCourseCertificate = (currentCourseId, label) => {
    const data = {
      id:currentCourseId,
      name: UserStore.userDetails?.name,
      interviewTopic: label,
      date: LearningStore.getCourseCompletionDate(id),
      autoDownload: true,
    };
    setDataToLocalStorage("certificate",data);
    console.log(data)
    // const query = queryString.stringify(data);
    // window.open(`/CourseCertificate?${query}`, "_blank");
    window.open(`/CourseCertificate`, "_blank");
  };

  return score == 100 ? (
    <div
      className="flex flex-col items-center w-fill mx-3 mb-4 h-56 w-56 lg:h-96 lg:w-96 cursor-pointer border bg-green-200 rounded-xl"
      // onClick={() => goToCourseById(id)}
    >
      <div className="p-4 lg:p-6">
        <img
          src={image}
          className="h-[80px] w-[80px] lg:h-[140px] lg:w-[140px] object-cover rounded-full opacity-60"
        />
      </div>
      <div>
        <p className=" w-56 text-center h-6 overflow-hidden gil-bold text-green-500 opacity-90 lg:text-3xl ">
          {label}
        </p>
      </div>
      <div className="text-purple-500 pb-3 lg:text-3xl lg:py-4 ">
        <p>Course Completed</p>
      </div>

      <div
        className="flex justify-center rounded-2xl lg:pt-3 bg-green-500 text-white w-[80%] p-2 lg:text-3xl"
        onClick={() => navigateToCourseCertificate(id, label)}
      >
        <button className="pr-2 lg:pr-3">Get Certificate</button>
        <img src={medal} className=" h-5 w-5 lg:h-8 lg:w-8 "></img>
      </div>
    </div>
  ) : null;
}
